"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NumberType;

var _FormControlLabel2 = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Autocomplete2 = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _ArrowDropDownRounded2 = _interopRequireDefault(require("@material-ui/icons/ArrowDropDownRounded"));

var _TextField2 = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _react = _interopRequireWildcard(require("react"));

var _Switch = _interopRequireDefault(require("../../components/Switch"));

var _propTypes = require("../../propTypes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var formatOptions = [{
  label: "Integer (2)",
  value: "integer"
}, {
  label: "Decimal (1.0)",
  value: "decimal"
}];
var precisionOptions = [{
  label: "1.0",
  value: 1
}, {
  label: "1.00",
  value: 2
}, {
  label: "1.000",
  value: 3
}, {
  label: "1.0000",
  value: 4
}];
NumberType.propTypes = _propTypes.OptionProps;

function NumberType(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      defaultValue = _ref.defaultValue,
      setDefaultValue = _ref.setDefaultValue,
      setOptions = _ref.setOptions;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      tab = _useState2[0],
      setTab = _useState2[1];

  var format = options.format ? formatOptions.find(function (_ref2) {
    var value = _ref2.value;
    return value === options.format;
  }) || {} : formatOptions[0];
  var precision = options.precision ? precisionOptions.find(function (_ref3) {
    var value = _ref3.value;
    return value === options.precision;
  }) : precisionOptions[0];

  var handleChangeFormat = function handleChangeFormat(e, item) {
    var newOption = _objectSpread(_objectSpread({}, options), {}, {
      format: item.value,
      precision: item.value === "decimal" ? 1 : 0
    });

    setOptions(newOption);
  };

  var handleChangePrecission = function handleChangePrecission(e, item) {
    var newOption = _objectSpread(_objectSpread({}, options), {}, {
      precision: item.value
    });

    setOptions(newOption);
  };

  var handleChangeNegative = function handleChangeNegative(e) {
    var newOption = _objectSpread(_objectSpread({}, options), {}, {
      negative: e.target.checked
    });

    setOptions(newOption);
  };

  return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    display: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    py: 1,
    px: 2,
    onClick: function onClick() {
      return setTab(0);
    },
    style: {
      backgroundColor: tab === 0 ? "rgba(0,0,0,0.05)" : "white",
      borderTopRightRadius: 4,
      borderTopLeftRadius: 4,
      cursor: "pointer",
      fontSize: "0.8rem"
    }
  }, "Format"), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    py: 1,
    px: 2,
    onClick: function onClick() {
      return setTab(1);
    },
    style: {
      backgroundColor: tab === 1 ? "rgba(0,0,0,0.05)" : "white",
      borderTopRightRadius: 4,
      borderTopLeftRadius: 4,
      cursor: "pointer",
      fontSize: "0.8rem"
    }
  }, "Default")), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    style: {
      backgroundColor: "rgba(0,0,0,0.05)"
    },
    mx: -2
  }, tab === 0 ? /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    p: 2
  }, /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    options: formatOptions,
    openOnFocus: true,
    blurOnSelect: true,
    disableClearable: true,
    onChange: handleChangeFormat,
    value: format,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({
        style: {
          backgroundColor: "white"
        }
      }, params, {
        variant: "outlined",
        size: "small",
        fullWidth: true
      }));
    },
    popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
    getOptionLabel: function getOptionLabel(item) {
      return item.label;
    }
  }), format.value === "decimal" ? /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mt: 2
  }, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    color: "textSecondary",
    variant: "subtitle2"
  }, "Precision"), /*#__PURE__*/_react["default"].createElement(_Autocomplete2["default"], {
    options: precisionOptions,
    openOnFocus: true,
    blurOnSelect: true,
    disableClearable: true,
    value: precision,
    onChange: handleChangePrecission,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react["default"].createElement(_TextField2["default"], _extends({
        style: {
          backgroundColor: "white"
        }
      }, params, {
        variant: "outlined",
        size: "small",
        fullWidth: true
      }));
    },
    popupIcon: /*#__PURE__*/_react["default"].createElement(_ArrowDropDownRounded2["default"], null),
    getOptionLabel: function getOptionLabel(item) {
      return item.label;
    }
  })) : null, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    mt: 2,
    px: 1
  }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel2["default"], {
    control: /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
      checked: options.negative,
      onChange: handleChangeNegative,
      name: "negative"
    }),
    label: /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, "Allow negative numbers")
  }))) : null, tab === 1 ? /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    p: 2
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: "rgba(156, 163, 175, 1)",
      marginBottom: "0.25rem"
    }
  }, "Prefill new cells with this number"), /*#__PURE__*/_react["default"].createElement(_TextField2["default"], {
    fullWidth: true,
    autoFocus: true,
    placeholder: "Default Number",
    variant: "outlined",
    size: "small",
    type: "number",
    onChange: function onChange(e) {
      var value = e.target.value;
      setDefaultValue(value === "" ? null : Number(value));
    },
    value: defaultValue,
    onClick: function onClick(e) {
      return e.target.focus();
    },
    style: {
      backgroundColor: "white"
    }
  }), /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    colo: true,
    variant: "caption"
  }, "Result :", " ", typeof defaultValue === "number" ? "".concat(Number(defaultValue).toFixed((format === null || format === void 0 ? void 0 : format.value) === "integer" ? 0 : precision === null || precision === void 0 ? void 0 : precision.value)) : null)) : null));
}